// extracted by mini-css-extract-plugin
export default {"title":"Orders_title__mWMpw","buttonsArea":"Orders_buttonsArea__0scuH","datePicker":"Orders_datePicker__EL+Oh","actionZone":"Orders_actionZone__L02j5"};